export default class CityTranslation {

    id: number;
    name: string;
    locale: string;
    city_id: number;
}
